import React from 'react';

const STORY_TEXT = `Sigmund was the one research project I was most passionate about in uni days. 

Applied Machine Learning, Fall 2021, first semester post-covid (covid was still around, we just had to go back to campus with restrictions anyway). 

I was 20, applying for master's / PhD programs, hoping that this work would heighten my chances of going to MIT. I remember how in my dorm room I had papers taped to the walls everywhere with different Linear Algebra, Time-Space Compexity, Statistical Models, etc. trying to figure out what architecture works best with the models available at the time. 

The many times I'd build and run my own Deep Learning models on my 2012 macbook air and have to go through the many times it'd freeze or completely turn unusable for a good few hours.

With all that, I managed to build an experimental version of it (one that, yes, if you saw it today, with the accessibility of modern AI models and current capabilities, you'd probably laugh), it wowed my professor and everyone in the class as I presented my final paper. Of course, I'm not OpenAI, given it was a uni project and I had no budget, it ended there, but it always stayed with me as something I wanted to rebuild.

So, what was Sigmund really? It was meant to be an assistant that you (and multiple people at the same time) can engage with in conversation and within those conversations display what it's working on and complete complex workflows in front of you, going as far as adapting to and controlling any OS. Yes, my version of J.A.R.V.I.S. from Marvel / Iron Man, essentially with a few more realistic add-ons.

In the coming weeks, we'll see where fate takes us.`;

export function StoryPage({ onContinue }) {
    return React.createElement(
        'div',
        { className: 'story-page' },
        React.createElement('h1', { className: 'story-title' }, '0_hello_world.md'),
        React.createElement('pre', { className: 'story-body' }, STORY_TEXT),
        React.createElement(
            'button',
            { className: 'story-back-btn', type: 'button', onClick: onContinue },
            '[ use sigmund ]'
        )
    );
}
